<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="back()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="uf-form" v-if="isRunningInBrowser">
			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>2</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 2 - Abonneren</v-list-tile-title>
						<v-list-tile-sub-title>Welk abonnement wil je afsluiten?</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

			<v-container class="item-group" mb-4>
				<h3>De betaling voor je abonnement is gelukt!</h3><br>
				<p>We hebben je een mail gestuurd met de bevestiging van je abonnement en de factuur.</p>
				<p>Om je E-Finder te activeren, moet deze eerst gekoppeld worden aan je telefoon. Dit gaat via Bluetooth in onze E-Finder app.</p>
				<p>Open de app op je telefoon. Als je hem nog niet hebt, download de app in de Appstore of Playstore.</p>
				<p></p>
				<v-layout row justify-center align-center mb-4>
					<a href="https://apps.apple.com/nl/app/e-finder/id1459518895">
						<img :src="images.badgeAppStore" height="40px" contain/>
					</a>
					<a href="https://play.google.com/store/apps/details?id=com.e_finder.app&gl=NL">
						<img :src="images.badgePlayStore" height="60px" contain/>
					</a>
				</v-layout>
				<v-btn block dark depressed large color="primary" @click="gotoOverview()">
					Terug naar het overzicht
				</v-btn>
			</v-container>
		</v-content>

		<v-content class="uf-form" v-else>
			<div v-if="device">
				<v-list two-line class="ma-0 pa-0">
					<v-list-tile two-line avatar class="e-connectz_list-tile">
						<v-list-tile-avatar>
							<strong>3</strong>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title class="font-weight-medium">Stap 3 - Koppelen</v-list-tile-title>
							<v-list-tile-sub-title>Koppel je E-finder aan je telefoon</v-list-tile-sub-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
				<v-container class="item-group">
					<p>We gebruiken een pincode om je E-finder te valideren. Deze sturen we je per sms.</p>
					<p>Controleer of de volgende code op je E-finder staat:</p>

					<div align="center">
						<h1 v-text="device.id_for_humans || '-'" class="mb-4"></h1>
					</div>

					<v-btn @click="next()" block dark depressed large color="primary">
						Stuur mij de pincode
					</v-btn>
				</v-container>
				<v-container>
					<v-layout class="column align-center">
						<p>Is {{ device.id_for_humans }} de verkeerde code van je E-finder?</p>
						<v-btn depressed color="white" @click="gotoUpdateCode()">Code wijzigen</v-btn>
					</v-layout>
				</v-container>
			</div>
		</v-content>
	</div>
</template>

<script>
  import badgePlayStore from '../../../assets/images/badge-nl-google-play.png';
  import badgeAppStore from '../../../assets/images/badge-nl-app-store.svg';
  import DeviceService from '../../../services/DeviceService';

  export default {
    computed: {
      device() {
        return this.$store.getters.device;
      },
      isRunningInBrowser() {
        return process.env.CORDOVA_PLATFORM === 'browser';
      }
    },
    watch: {
      code(value) {
        this.$nextTick(() => {
          this.code = value.replace(/[^0-9A-Fa-f]+/gi, '')
            .toUpperCase();
        });
      }
    },
    data() {
      return {
        code: '',
        state: 'idle',
        images: {
          badgeAppStore: badgeAppStore,
          badgePlayStore: badgePlayStore
        },
      };
    },
    methods: {
      showMenu() {
        this.$store.dispatch('toggleMainMenu');
      },
      gotoUpdateCode() {
        this.$router.push({ name: 'devices.activate.code', params: { id: this.device.id }});
	  },
      back() {
        this.$router.push({ name: 'devices.activate' });
      },
      next() {
        DeviceService.requestPin(this.device.id)
          .then(() => this.$router.push({ name: 'devices.activate.link', params: { id: this.device.id } }))
          .catch(() => this.$router.push({ name: 'devices.activate.link', params: { id: this.device.id } }));
      }
    },
    created() {
      this.$store.dispatch('selectDevice', this.$route.params.id)
        .then((d) => {
          this.code = d.id_for_humans;
        });
    },
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd
</style>
